/** Thai strings for the classroom (class board, weekly class goal) and for opening a friend's notebook (English source text -> Thai). */
export const CLASSROOM: Record<string, string> = {
  // Class page
  'My Class': 'ห้องเรียนของฉัน',
  'One class code, the whole class in one notebook.': 'รหัสห้องเดียว ทั้งห้องอยู่ในสมุดเล่มเดียวกัน',
  '← Friends': '← เพื่อน',
  'Opening the class register…': 'กำลังเปิดสมุดรายชื่อห้อง…',
  'Sign in to the battle server to join a class.': 'เข้าสู่ระบบเซิร์ฟเวอร์ก่อน แล้วค่อยเข้าห้องเรียนนะ',
  'Battle server offline — the class is unavailable right now.': 'เซิร์ฟเวอร์ออฟไลน์ — ตอนนี้เปิดห้องเรียนไม่ได้',
  'Join a class': 'เข้าห้องเรียน',
  'Ask your teacher or a classmate for the class code.': 'ขอรหัสห้องจากคุณครูหรือเพื่อนร่วมห้อง',
  'Class code': 'รหัสห้อง',
  'Class codes have 6 letters/numbers, like ABC-123.': 'รหัสห้องมีตัวอักษร/ตัวเลข 6 ตัว เช่น ABC-123',
  'Welcome to {name}!': 'ยินดีต้อนรับสู่{name}!',
  'Start a class': 'สร้างห้องเรียน',
  'The game picks a friendly class name and gives you a code to share. Up to {n} classmates.': 'เกมจะตั้งชื่อห้องน่ารักๆ ให้ และให้รหัสห้องไว้แชร์ รับเพื่อนได้สูงสุด {n} คน',
  '{name} is ready! Share the code {code}.': '{name} พร้อมแล้ว! แชร์รหัส {code} ให้เพื่อนๆ',
  'Class code — tell your classmates:': 'รหัสห้อง — บอกเพื่อนร่วมห้องได้เลย:',
  'Class code copied!': 'คัดลอกรหัสห้องแล้ว!',
  'The game picks another friendly name': 'ให้เกมตั้งชื่อน่ารักๆ ชื่อใหม่',
  'Your class is now called {name}.': 'ตอนนี้ห้องของเราชื่อ {name} แล้ว',
  '{n} / {max} classmates · run by {name}': 'เพื่อนร่วมห้อง {n} / {max} คน · หัวหน้าห้อง {name}',
  'Classmates ({n})': 'เพื่อนร่วมห้อง ({n})',
  '{n} battle this week': 'สัปดาห์นี้สู้ {n} ครั้ง',
  '{n} battles this week': 'สัปดาห์นี้สู้ {n} ครั้ง',
  'class owner': 'หัวหน้าห้อง',
  Notebook: 'สมุด',
  'friend request waiting': 'รอตอบคำขอเป็นเพื่อน',
  'Take out': 'เชิญออก',
  'Take {name} out of the class?': 'เชิญ {name} ออกจากห้องไหม?',
  '{name} will not be able to join this class again.': '{name} จะกลับเข้าห้องนี้อีกไม่ได้',
  '{name} left the class.': '{name} ออกจากห้องแล้ว',
  'Class Monster Shelf': 'ชั้นวางมอนสเตอร์ของห้อง',
  'Shared by you': 'เราแชร์เอง',
  'Shared by {name}': '{name} แชร์มา',
  'Nobody shared a monster yet. Share one from Collection → My Doodles!': 'ยังไม่มีใครแชร์มอนสเตอร์เลย แชร์ได้ที่ คอลเลกชัน → ภาพวาดของฉัน!',
  'Only classmates see this shelf.': 'ชั้นวางนี้เห็นกันแค่ในห้องเท่านั้น',
  'That monster does not fit the rules any more.': 'มอนสเตอร์ตัวนี้ไม่ตรงกติกาแล้ว',
  'Leave the class': 'ออกจากห้อง',
  'Leave {name}?': 'ออกจาก{name}ไหม?',
  'The classmate who joined first will run the class.': 'เพื่อนที่เข้าห้องก่อนใครจะได้เป็นหัวหน้าห้องแทน',
  'You are the last one here, so the class closes.': 'เราเป็นคนสุดท้ายในห้องแล้ว ห้องนี้จะปิดไป',
  'You can join again with the class code.': 'กลับเข้ามาใหม่ได้ด้วยรหัสห้อง',
  'You left {name}.': 'ออกจาก{name}แล้ว',

  // Weekly class goal
  "This Week's Class Goal": 'เป้าหมายห้องประจำสัปดาห์',
  'Every battle counts, win or lose! Fight {target} battles together this week.': 'ทุกการต่อสู้นับหมด แพ้หรือชนะก็ได้! สัปดาห์นี้มาสู้ให้ครบ {target} ครั้งด้วยกัน',
  'Goal reached! Great teamwork.': 'ถึงเป้าแล้ว! ทีมเวิร์กสุดยอด',
  '{n} battle to go.': 'อีก {n} ครั้ง',
  '{n} battles to go.': 'อีก {n} ครั้ง',
  'My battles: {n} (up to {cap} count).': 'ของเรา: {n} ครั้ง (นับสูงสุด {cap} ครั้ง)',
  '+{n} coins for the class goal!': 'ได้ +{n} เหรียญจากเป้าหมายห้อง!',
  CLAIMED: 'รับแล้ว',
  'Fight one battle this week to share the prize.': 'สู้สักครั้งในสัปดาห์นี้ เพื่อรับรางวัลด้วยกัน',
  'Reach the goal and everyone who helped gets +{n} coins.': 'ถึงเป้าเมื่อไร ทุกคนที่ช่วยกันได้ +{n} เหรียญ',
  'New goal {when}.': 'เป้าหมายใหม่ {when}',
  '{name} reached the class goal!': '{name} ทำเป้าหมายห้องสำเร็จ!',
  '{n} battles together this week. +{coins} coins for helping.': 'สัปดาห์นี้สู้ด้วยกัน {n} ครั้ง ได้ +{coins} เหรียญที่มาช่วย',
  'Your class reached its goal! Claim your coins in Notebook → Friends → My Class.': 'ห้องของเราถึงเป้าแล้ว! รับเหรียญได้ที่ สมุด → เพื่อน → ห้องเรียนของฉัน',

  // "My Class" note on the Friends page
  'Open the class board': 'เปิดกระดานห้อง',
  'goal {progress} / {target}': 'เป้าหมาย {progress} / {target}',
  'PRIZE!': 'มีรางวัล!',
  'Join your class with a class code, or start one.': 'เข้าห้องด้วยรหัสห้อง หรือสร้างห้องใหม่',
  'Join or start a class': 'เข้าหรือสร้างห้องเรียน',
  '{n} classmate': 'เพื่อนร่วมห้อง {n} คน',
  '{n} classmates': 'เพื่อนร่วมห้อง {n} คน',

  // A friend's notebook
  "{name}'s Notebook": 'สมุดของ {name}',
  "Open {name}'s notebook": 'เปิดสมุดของ {name}',
  Close: 'ปิด',
  'Playing a level {level} {cls}': 'เล่น{cls} เลเวล {level}',
  'No hero yet.': 'ยังไม่มีฮีโร่',
  '{name} has not opened their notebook online yet.': '{name} ยังไม่เคยเปิดสมุดตอนออนไลน์',
  Stationery: 'เครื่องเขียน',
  'Contest wins': 'ชนะประกวด',
  'Last updated {date}': 'อัปเดตล่าสุด {date}',
  '{monster} won {round}': '{monster} ชนะรอบ {round}',
  'No contest wins yet.': 'ยังไม่เคยชนะการประกวด',
  'Shared Monsters': 'มอนสเตอร์ที่แชร์',
  '{name} has not shared a monster yet.': '{name} ยังไม่ได้แชร์มอนสเตอร์',
  'Shared {date}': 'แชร์เมื่อ {date}',
  'Tape into my notebook': 'แปะลงสมุดของฉัน',
  'IN MY NOTEBOOK': 'อยู่ในสมุดแล้ว',

  // Server errors (shown through errorText)
  'You are already in a class; leave it first.': 'เราอยู่ในห้องเรียนอยู่แล้ว ออกจากห้องเดิมก่อนนะ',
  'You are not in a class.': 'เรายังไม่ได้อยู่ในห้องเรียน',
  'No class has that code.': 'ไม่มีห้องเรียนที่ใช้รหัสนี้',
  'That class is full.': 'ห้องนี้เต็มแล้ว',
  'The class owner took you out of that class.': 'หัวหน้าห้องเชิญเราออกจากห้องนี้แล้ว',
  'Only the class owner can do that.': 'หัวหน้าห้องเท่านั้นที่ทำได้',
  'That player is not in your class.': 'ผู้เล่นคนนี้ไม่ได้อยู่ในห้องของเรา',
  'You cannot take yourself out; leave the class instead.': 'เชิญตัวเองออกไม่ได้ ให้กด "ออกจากห้อง" แทน',
  'That class week is over.': 'สัปดาห์ของห้องนี้จบไปแล้ว',
  'Notebook card is out of range.': 'ข้อมูลสมุดไม่ถูกต้อง',
  "You can only open your friends' notebooks.": 'เปิดสมุดได้เฉพาะของเพื่อนเท่านั้น',
};
